const types = {
  RESET_APP: "RESET_APP",
  SWITCH_COMPANY: "SWITCH_COMPANY",
};

export default types;
